module.exports = __webpack_public_path__ + "static/media/20.6ef77146.jpg";